import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CirfService} from "../cirf.service";
import {Cirf} from "../cirf";
import {CirfClientInfo} from "../cirf-client-info";
import {ActivatedRoute, Router} from "@angular/router";
import {Utils} from "../../common/utils";
import {SESSION_STORAGE_KEYS} from "../../common/session-storage-keys";
import {ConfirmDialogService} from "../../common/confirm-dialog/confirm-dialog.service";
import {CirfMortgage, MortgageTypeValue} from "../cirf-mortgage";
import {CirfMatterData} from "../cirf-matter-data";
import {DatePipe} from "@angular/common";
import {CirfMatterContactInfo} from "../cirf-matter-contact-info";
import {ConnectDialog} from "../../common/confirm-dialog/connect-dialog";
import {
    CIRF_ADDITIONAL_TOPICS,
    CIRF_CLIENT_TOPICS, CIRF_EXISTING_MORTGAGE_NOTES_TOPICS,
    CIRF_NAME_KEYS, CIRF_NEW_MORTGAGE_NOTES_TOPICS,
    CIRF_OTHER_TOPICS,
    DpBooleanValueTypes
} from "../../shared/constants";
import {FormGroup} from '@angular/forms';
import {CirfConfig} from "../config/cirf-config";
import {CirfConfigService} from "../config/cirf-config-service";
import {CirfNavigation, NavigationSection} from "../cirf-navigation";
import {CirfInsuranceDetail} from "../cirf-insurance-detail";
import {ConnectCirfComponent} from "../form/connect-cirf.component";
import {ClientNameLookupDialogParams} from "../cirf-lookup/client-name-lookup-dialog.component";
declare var jQuery : any;

@Component({
    selector: 'dp-connect-cirf-client-list',
    templateUrl: './connect-cirf-client-list.html',
    providers: [DatePipe]
})
export class ConnectCirfClientListComponent implements OnInit {

    connectToken: string;
    message: string;
    existingMortgageId: string;
    clientId: string;
    isLoading: boolean;
    isSubmitted: boolean = false;

    @ViewChild('pageContent') pageContent: ElementRef;
    @ViewChild('backToTopBtn') backToTopBtn: ElementRef;
    @ViewChild('connectCirf') connectCirf: ConnectCirfComponent;

    constructor(public cirfService: CirfService, public router: Router,
                private route: ActivatedRoute,
                public confirmDialogService: ConfirmDialogService,
                private cirfConfigService: CirfConfigService,
                public datePipe: DatePipe) {

    }


    ngOnInit(): void {
        this.initializeComponent();
    }

    async initializeComponent(): Promise<void> {
        this.isLoading = true;
        await this.setUpCirf();
        this.initiateCirfNavigation();
        this.isLoading = false;
    }

    initiateCirfNavigation() {
        this.cirfService.cirfNavigation = new CirfNavigation();
        this.buildNavigationSections();

        this.cirfService.cirfNavigation.resetSelection();
        // Retrieve the last visited section
        if (this.selectedNavSection && !this.selectedNavSection.isReviewSubmitSection()) {
            this.cirfService.cirfNavigation.selectedClientIndex = this.selectedNavSection.clientIndex;
            this.cirfService.cirfNavigation.selectedTopicKey = this.selectedNavSection.topicKey;
            this.cirfService.cirfNavigation.selectedSectionKey = this.selectedNavSection.sectionKey;
            this.cirfService.cirfNavigation.selectedNewMortgageIndex = this.selectedNavSection.newMortgageIndex;
            this.cirfService.cirfNavigation.selectedExistingMortgageIndex = this.selectedNavSection.existingMortgageIndex;
        } else {
            this.cirfService.cirfNavigation.selectedClientIndex = 0;
            this.cirfService.cirfNavigation.selectedTopicKey = CIRF_CLIENT_TOPICS[0].topicKey;
            this.cirfService.cirfNavigation.selectedSectionKey = CIRF_CLIENT_TOPICS[0].topicSections[0].sectionKey;
            this.cirfService.cirfNavigation.selectedNewMortgageIndex = -1;
            this.cirfService.cirfNavigation.selectedExistingMortgageIndex = -1;
        }
        this.openClientNameLookupDialogFromNav();
    }

   async openClientNameLookupDialogFromNav(): Promise<void> {
        let cirfClient;
        if (this.cirf && this.cirf.cirfClients && this.cirf.cirfClients.length > this.cirfService.cirfNavigation.selectedClientIndex) {
            cirfClient = this.cirf.cirfClients[this.cirfService.cirfNavigation.selectedClientIndex];
        }
        if (cirfClient && cirfClient.agreedToUploadDL == undefined && this.cirfService.cirfNavigation && this.cirfService.cirfNavigation.selectedSectionKey == CIRF_NAME_KEYS.personalDetails.key
            && this.cirfService.cirfNavigation.selectedTopicKey == CIRF_NAME_KEYS.contactInfo.key) {
            let clientNameLookupDialogParams = new ClientNameLookupDialogParams();
            clientNameLookupDialogParams.cirfClient = cirfClient;
            let result = await this.cirfService.openClientNameLookupDialog(clientNameLookupDialogParams).toPromise();
            if (result && result.cirfClient && result.sourceCirfGuid) {
                let selectedIndex = this.cirfService.cirfNavigation.selectedClientIndex;
                this.cirf.cirfClients[this.cirfService.cirfNavigation.selectedClientIndex] = result.cirfClient;
                this.cirfService.setUpFormControl(this.cirf);
                await this.updateCirfAndCopyDocuments(result.cirfClient.id , result.sourceCirfGuid, result.sourceSourceId);
                this.cirfNavigation.resetSelection();
                this.buildNavigationSections();
                this.cirfNavigation.selectedClientIndex = selectedIndex;
                this.setClientProfileTopic();
            }
            this.focusFirstRow();
        }
    }

    get selectedNavSection(): NavigationSection {
        return this.cirfService.selectedNavSection;
    }


    setCirfMesssage(): void {
        if (this.cirf && this.cirf.isExpired()) {
            this.message = `This ${this.matterTypeText} Matter Information Request has expired. Please contact your solicitor.`;
        }
    }

    get cirf(): Cirf {
        return this.cirfService.cirf;
    }

    get isCirfExpired(): boolean {
        return this.cirf ? this.cirf.isExpired() : false;
    }

    get clients(): CirfClientInfo[] {
        return this.cirf ? this.cirf.cirfClients : [];
    }

    get cirfMatterContactInfo(): CirfMatterContactInfo {
        return this.cirf?.matterContactInfo;
    }

    get cirfInsuranceDetail(): CirfInsuranceDetail {
        return this.cirf?.fireInsuranceDetail;
    }

    get newMortgages(): CirfMortgage[] {
        return this.cirf ? this.cirf.newMortgages : [];
    }

    get existingMortgages(): CirfMortgage[] {
        return this.cirf ? this.cirf.existingMortgages : [];
    }

    get matterData(): CirfMatterData {
        return this.cirf?.cirfMatterData;
    }

    getPersonalDetailsText(): string {
        if (this.cirf && this.cirf.isParticipantCirf()) {
            return 'Please enter the personal details, including contact info, marital status, and ID information, for this individual.'
        } else {
            return 'Please enter the personal details, including contact info, marital status, and ID information, for all individuals. You can use the Add New button to add additional individuals.'
        }
    }

    async addNewClient(): Promise<void> {
        let clientNameLookupDialogParams = new ClientNameLookupDialogParams();
        clientNameLookupDialogParams.cirfClient = undefined;
        let result = await this.cirfService.openClientNameLookupDialog(clientNameLookupDialogParams).toPromise();
        if (result && result.cirfClient) {
            this.cirfService.clients.push(result.cirfClient);
            this.cirfService.setUpFormControl(this.cirf);
            await this.updateCirfAndCopyDocuments(result.cirfClient.id , result.sourceCirfGuid, result.sourceSourceId);

        } else {
            this.createClientInfo();
        }
        this.cirfNavigation.resetSelection();
        this.buildNavigationSections();
        this.cirfNavigation.selectedClientIndex = this.clients?.length - 1;
        this.setClientProfileTopic();
        this.focusFirstRow();

    }

    async updateCirfAndCopyDocuments(cirfSourceId : string ,sourceCirfGuid: string, sourceSourceId: string): Promise<void> {
        await this.cirfService.updateCirf('INPROGRESS');
        if (sourceCirfGuid && sourceSourceId) {
          let cirfDocuments = await this.cirfService.copyCirfClientDocuments(this.cirf.cirfGuid, cirfSourceId, sourceCirfGuid, sourceSourceId).toPromise();
          if(cirfDocuments && cirfDocuments.length > 0 &&  this.connectCirf){
              this.connectCirf.startPolling();
          }
        }
    }

    setClientProfileTopic(): void {
        this.cirfService.cirfNavigation.selectedTopicKey = CIRF_CLIENT_TOPICS[0].topicKey;
        this.cirfService.cirfNavigation.selectedSectionKey = CIRF_CLIENT_TOPICS[0].topicSections[0].sectionKey;
        this.updateClientProfileTopicSection();
    }

    updateClientProfileTopicSection(){
        let navigationSection : NavigationSection = new NavigationSection();
        navigationSection.clientIndex = this.cirfService.cirfNavigation.selectedClientIndex;
        navigationSection.topicKey = this.cirfService.cirfNavigation.selectedTopicKey;
        navigationSection.sectionKey = this.cirfService.cirfNavigation.selectedSectionKey;
        this.updateNavigationSectionList(navigationSection);
    }

    createClientInfo(): CirfClientInfo {
        let cirfClientInfo = new CirfClientInfo();
        cirfClientInfo.id = Utils.uuid();
        cirfClientInfo.gender = 'QUESTION';
        this.cirfService.clients.push(cirfClientInfo);
        this.cirfService.setUpFormControl(this.cirf);
        this.cirfService.saveChangesOnCirfFormChanges();
        return cirfClientInfo;
    }

    editClient(id: string) {
        this.router.navigate(['../form/' + id], {relativeTo: this.route});
    }

    deleteClient(id: string) {
        let connectDialog = new ConnectDialog();
        connectDialog.message = 'Are you sure you want to delete this information?'
        connectDialog.dialogType = 'WARNING';
        this.confirmDialogService.confirmDialog(connectDialog).subscribe(
            res => {
                if (res) {
                    let clientindex = this.cirf.cirfClients.findIndex(item => item.id == id);
                    if (clientindex > -1) {
                        //remove spouse link if exists
                        let spouseId: string = this.cirf.cirfClients[clientindex].spouseId;
                        if (spouseId) {
                            let spouse: CirfClientInfo = this.cirfService.getClient(spouseId);
                            if (spouse) {
                                spouse.spouseId = '';
                                spouse.spouseName = '';
                                spouse.isSpouseOnTitle = DpBooleanValueTypes.NO;
                            }
                        }

                        this.cirf.cirfClients.splice(clientindex, 1);
                        this.cirfService?.cirf?.cirfMatterData?.removeClientAccessNavSections(this.cirfNavigation?.selectedClientIndex);
                        this.saveCirf();
                        this.refreshAfterDelete();

                    }
                }
            }
        )
    }

    refreshAfterDelete(): void {
        this.cirfNavigation.resetSelection();
        this.buildNavigationSections();
        this.cirfNavigation.selectedClientIndex = 0;
        this.setClientProfileTopic();
    }

    cleanMortgage() {
        if (this.cirfService?.cleanMortgageIds?.length > 0) {
            this.cirfService.cleanMortgageIds.forEach(cleanMortgageId => {
                let mortgageIndex = this.cirf?.mortgages?.findIndex(item => item.id == cleanMortgageId);
                if (mortgageIndex > -1) {
                    this.cirf.mortgages.splice(mortgageIndex, 1);
                }
            });
        }
    }

    async submitCirf(): Promise<void> {
        if (!this.hasErrors() && !this.isCirfExpired) {
            this.cirf.status = 'SUBMITTED';
            this.cleanupClientDocuments();
            this.cleanMortgage();
            this.cleanupCapacity();
            await this.saveCirf(true, true);
            this.goToSummaryPage();

        } else if (this.hasErrors()) {
            this.isSubmitted = true;
            let connectDialog = new ConnectDialog();
            connectDialog.message = `${this.matterTypeText} Matter Information Request has incomplete information, please complete all required information before submitting your request`
            connectDialog.dialogType = 'ERROR';
            connectDialog.showCancelBtn = false;
            this.confirmDialogService.confirmDialog(connectDialog).subscribe();

        }
    }

    cleanupClientDocuments(): void {
        if (this.clients && this.clients.length && this.cirf.cirfDocuments && this.cirf.cirfDocuments.length) {
            this.clients.forEach((client) => {
                if (!client.isPermanentResident()) {
                    let permanentResidentCard = this.cirf.cirfDocuments.find(doc => doc.sourceId == client.id);
                    if (permanentResidentCard) {
                        (<any>this.cirf.cirfDocuments).remove(permanentResidentCard);
                    }
                }
            })
        }
    }

    cleanupCapacity(): void {
        if (this.matterData && this.matterData.matterContactInfo && this.matterData.matterContactInfo.isClientCapacityEmpty()) {
            this.matterData.matterContactInfo.clientCapacity = 'UNSPECIFIED_CAPACITY';
        }
    }

    async saveCirf(showConfirmDialog?: boolean, isSubmit?: boolean): Promise<void> {
        this.cirf.cleanUpCirf();
        let cirfUpdated = await this.cirfService.saveCirf(this.cirf, this.connectToken, isSubmit).toPromise();
        if (!!showConfirmDialog) {
            let connectDialog = new ConnectDialog();
            connectDialog.message = `This information has been successfully submitted  ${this.firmName ? 'to ' + this.firmName : ''}`
            connectDialog.dialogType = 'SUCCESS';
            connectDialog.notes = 'You can update this information and submit again at any time.';
            connectDialog.showCancelBtn = false;
            this.confirmDialogService.confirmDialog(connectDialog).subscribe();
        }
        this.cirfService.cirf = cirfUpdated;
        this.cirfService.setUpFormControl(cirfUpdated);
    }

    hasErrors(): boolean {
        return this.anyClientHasError() || this.isPropertyHasError() || this.isInsuranceHasError() || this.anyNewMortgageHasError() || this.anyExistingMortgageHasError();
    }

    editMatterInfo() {
        this.router.navigate(['../matter-property-info'], {relativeTo: this.route});
    }

    addNewMortgage(): void {
        this.createMortgage(MortgageTypeValue.New);
        this.cirfNavigation.resetSelection();
        this.buildNavigationSections();
        this.cirfNavigation.selectedNewMortgageIndex = this.newMortgages?.length - 1;
        let navigationSection = this.cirfNavigation.navigationSections.find(item=> item.newMortgageIndex == this.cirfNavigation.selectedNewMortgageIndex);
        this.updateNavigationSectionList(navigationSection);
        //this.router.navigate(['../mortgage-form/'+mortgage.id],{relativeTo: this.route});
        this.focusFirstRow();
    }

    addExistingMortgage(): void {
        this.createMortgage(MortgageTypeValue.Existing);
        this.cirfNavigation.resetSelection();
        this.buildNavigationSections();
        this.cirfNavigation.selectedExistingMortgageIndex = this.existingMortgages?.length - 1;
        let navigationSection = this.cirfNavigation.navigationSections.find(item=> item.existingMortgageIndex == this.cirfNavigation.selectedExistingMortgageIndex);
        this.updateNavigationSectionList(navigationSection);
        this.focusFirstRow();
        //this.router.navigate(['../mortgage-form/'+mortgage.id],{relativeTo: this.route});
    }

    editMortgage(id: string) {
        this.router.navigate(['../mortgage-form/' + id], {relativeTo: this.route});
    }

    createMortgage(mortgageType: string): CirfMortgage {
        let mortgage = this.cirfService.createMortgageAction(mortgageType);
        this.cirfService.saveChangesOnCirfFormChanges();
        return mortgage;
    }

    deleteMortgage(id: string) {
        let connectDialog = new ConnectDialog();
        connectDialog.message = 'Are you sure you want to delete this information?'
        connectDialog.dialogType = 'WARNING';
        this.confirmDialogService.confirmDialog(connectDialog).subscribe(
            res => {
                if (res) {
                    let mortgageIndex = this.cirf.mortgages.findIndex(item => item.id == id);
                    if (mortgageIndex > -1) {
                        this.cirf.mortgages.splice(mortgageIndex, 1);
                        this.saveCirf();
                        this.refreshAfterDelete();
                    }
                }
            }
        )
    }

    deleteMortgageAction(id: string) {
        let mortgageIndex = this.cirf.mortgages.findIndex(item => item.id == id);
        if (mortgageIndex > -1) {
            this.cirf.mortgages.splice(mortgageIndex, 1);

        }

    }


    get matterTypeText(): string {
        return this.cirfService?.matterTypeText;
    }

    isCustomMatter(): boolean {
        return this.matterData && this.matterData.isCustomMatter();
    }

    get firmName(): string {
        return this.matterData?.firmName;
    }

    get propertyAddressText(): string {
        return this.matterData?.propertyAddressText;
    }

    get legalDescriptionSummary(): string {
        return this.matterData?.legalDescriptionSummary.substring(0, 100);
    }

    get closingDateText(): string {
        return this.matterData?.closingDate ? this.datePipe.transform(this.matterData.closingDate, 'mediumDate') : '';
    }

    get lastSubmittedText(): string {
        return this.cirf?.lastSubmittedTimeStamp ? this.datePipe.transform(this.cirf.lastSubmittedTimeStamp, 'mediumDate') : '';
    }

    printCirf(): void {
        this.router.navigate(['../print-cirf'], {relativeTo: this.route});
    }

    anyClientHasError() {
        return this.clients && this.clients.some(client => client.hasErrors);
    }

    isPropertyHasError() {
        return (this.cirfMatterContactInfo && this.cirfMatterContactInfo.hasErrors)
            || (this.cirfService.cirfFormGroup.get('cirfMatterData')['controls'].matterNotes.errors);

    }

    isInsuranceHasError() {
        return this.cirfInsuranceDetail && this.cirfInsuranceDetail.hasErrors
            || (this.cirfService.cirfFormGroup.get('cirfMatterData')['controls'].insuranceNotes.errors);
        ;
    }

    anyNewMortgageHasError() {
        return this.newMortgages && this.newMortgages.some(mtg => mtg.hasErrors);
    }

    anyExistingMortgageHasError() {
        return this.existingMortgages && this.existingMortgages.some(mtg => mtg.hasErrors);
    }

    async initializeCirfConfig() {
        await this.cirfConfigService.getMatterCirfConfig(this.cirf.matterId).toPromise();
    }

    async setUpCirf(): Promise<void> {
        this.connectToken = sessionStorage.getItem(SESSION_STORAGE_KEYS.connectToken);

        //if(this.connectToken && (!this.cirf || this.connectToken!=this.cirf.guid)){
        if (this.connectToken) {
            let cirf = this.cirfService.cirf;
            if (!cirf || cirf.guid !== this.connectToken) {
                cirf = await this.cirfService.getCirf(this.connectToken).toPromise();
                this.cirfService.saveCirfToSessionStorage(cirf);
                this.cirfService.cirf = cirf;
            }
            await this.initializeCirfConfig();
            this.cirfService.setUpFormControl(cirf);
            this.cirfService.checkErrors(this.cirf);
            this.setCirfMesssage();

        }
    }

    closeNav(): void {
        document.getElementById("cirfSideNav").style.width = "0";
    }

    openNav(): void {
        document.getElementById("cirfSideNav").style.width = "250px";
    }

    get selectedSectionTitle(): string {
        let title = '';
        if (this.cirfNavigation) {
            if (this.selectedNewMortgage) {
                return this.selectedNewMortgage.bankName ? this.selectedNewMortgage.bankName : 'New Mortgage';
            } else if (this.selectedExistingMortgage) {
                return this.selectedExistingMortgage.bankName ? this.selectedExistingMortgage.bankName : 'Existing Mortgage';
            } else if (this.cirfNavigation.selectedClientIndex >= 0) {
                if (this.cirfNavigation.selectedTopicKey == CIRF_NAME_KEYS.clientNotesTopic.key) {
                    return CIRF_NAME_KEYS.clientNotesTopic.title;
                }

                //title = CIRF_CLIENT_TOPICS[0].topicName;
                if (this.cirf && this.cirf.cirfMatterData && this.cirf.cirfMatterData.cirfClients && this.cirf.cirfMatterData.cirfClients.length) {
                    title += this.cirf.cirfMatterData.cirfClients[this.cirfNavigation.selectedClientIndex].fullName;
                }
            } else {
                let otherTopics = [...CIRF_OTHER_TOPICS, ...CIRF_ADDITIONAL_TOPICS, ...CIRF_NEW_MORTGAGE_NOTES_TOPICS, ...CIRF_EXISTING_MORTGAGE_NOTES_TOPICS];
                let selectedTopic = otherTopics.find(item => item.topicKey == this.cirfNavigation.selectedTopicKey);
                if (selectedTopic) {
                    title = selectedTopic.topicName;
                    // let selectedSection = selectedTopic.topicSections.find(item=>item.sectionKey == this.cirfNavigation.selectedSectionKey);
                    // if(selectedSection){
                    //     title = selectedSection.sectionName;
                    // }
                }

            }

        }
        return title;
    }

    get cirfNavigation(): CirfNavigation {
        return this.cirfService.cirfNavigation;
    }

    updateNavigationSectionList(resetSelection: NavigationSection){
        if(this.cirfService?.cirf?.cirfMatterData && !Array.isArray(this.cirfService.cirf.cirfMatterData.accessNavSections)){
            this.cirfService.cirf.cirfMatterData.accessNavSections = [];
        }
        if(this.cirfService?.cirf?.cirfMatterData && resetSelection){
            if(!this.cirfService.cirf.cirfMatterData.findExistingAccessNavSection(resetSelection)){
                this.cirfService.cirf.cirfMatterData.accessNavSections.push(new NavigationSection(resetSelection));
            }
        }

    }

    focusFirstRow(): void {
        setTimeout(() => {
            jQuery('[my-auto-focus]').focus();
        }, 500)
    }

    checkFocusCall(cirfNavigation: CirfNavigation, navigationSection){
        if(cirfNavigation && navigationSection
            && ((cirfNavigation.selectedClientIndex != navigationSection.clientIndex
                && cirfNavigation.selectedTopicKey == navigationSection.topicKey
                && cirfNavigation.selectedSectionKey == navigationSection.sectionKey)
                || (navigationSection.newMortgageIndex >=0 && cirfNavigation.selectedNewMortgageIndex != navigationSection.newMortgageIndex)
                || (navigationSection.existingMortgageIndex >=0 && cirfNavigation.selectedExistingMortgageIndex != navigationSection.existingMortgageIndex))){
            this.focusFirstRow();
        }

    }

    setSelectedTopicAndSection(result: any): void {
        let selectedNewMortgageIndex;
        let selectedExistingMortgageIndex;
        if (this.cirfNavigation) {
            let deleteMortgage;
            if(this.cirfNavigation.selectedNewMortgageIndex > -1 && this.newMortgages?.length > 0 && this.cirfNavigation?.selectedNewMortgageIndex < this.newMortgages?.length
                && this.newMortgages[this.cirfNavigation?.selectedNewMortgageIndex].isCirfMortgageEmpty()){
                if(this.cirfNavigation.selectedNewMortgageIndex != result.navigationSection.newMortgageIndex) {
                    deleteMortgage = this.newMortgages[this.cirfNavigation?.selectedNewMortgageIndex];
                    selectedNewMortgageIndex = this.cirfNavigation?.selectedNewMortgageIndex;
                }
            }

            if(this.cirfNavigation.selectedExistingMortgageIndex > -1  && this.existingMortgages?.length > 0 && this.cirfNavigation?.selectedNewMortgageIndex < this.existingMortgages?.length
                && this.existingMortgages[this.cirfNavigation?.selectedExistingMortgageIndex].isCirfMortgageEmpty()){
                if(this.cirfNavigation.selectedExistingMortgageIndex != result.navigationSection.existingMortgageIndex) {
                    deleteMortgage = this.existingMortgages[this.cirfNavigation?.selectedExistingMortgageIndex];
                    selectedExistingMortgageIndex = this.cirfNavigation?.selectedExistingMortgageIndex;
                }
            }

            this.checkFocusCall(this.cirfNavigation, result.navigationSection);

            this.cirfNavigation.resetSelection();
            let navigationSection = result.navigationSection;
            this.cirfNavigation.selectedClientIndex = navigationSection.clientIndex;
            this.cirfNavigation.selectedTopicKey = navigationSection.topicKey;
            this.cirfNavigation.selectedSectionKey = navigationSection.sectionKey;
            this.cirfNavigation.selectedNewMortgageIndex = navigationSection.newMortgageIndex;
            this.cirfNavigation.selectedExistingMortgageIndex = navigationSection.existingMortgageIndex;
            if (this.cirfNavigation.selectedNewMortgageIndex === 0 && (!this.newMortgages || this.newMortgages.length == 0)) {
                this.cirfService.createMortgageAction(MortgageTypeValue.New);
            }
            if (this.cirfNavigation.selectedExistingMortgageIndex === 0 && (!this.existingMortgages || this.existingMortgages.length == 0)) {
                this.cirfService.createMortgageAction(MortgageTypeValue.Existing);
            }
            this.updateNavigationSectionList(result.navigationSection);
            if(deleteMortgage){
                this.deleteMortgageAction(deleteMortgage.id);
                this.buildNavigationSections();
                if(selectedNewMortgageIndex > -1){
                    this.cirfService.cirf?.cirfMatterData?.removeMortgageAccessNavSection(true, selectedNewMortgageIndex);
                }
                if(selectedExistingMortgageIndex > -1){
                    this.cirfService.cirf?.cirfMatterData?.removeMortgageAccessNavSection(false, selectedExistingMortgageIndex);
                }
                //Wwe need to update FormControl, avoid the following line will got wrong value
                // const cirf = new Cirf(this.cirfFormGroup.getRawValue());
                this.cirfService.setUpFormControl(this.cirf);
                this.saveCirf();
            }

            this.openClientNameLookupDialogFromNav();
        }
        this.closeNav();
    }

    goToSummaryPage(): void {
        this.router.navigate(['./home/matter-summary-home'], {state: {nextState: 'refresh'}});
    }

    get selectedNewMortgage(): CirfMortgage {
        if (this.cirfNavigation && this.cirfNavigation.selectedNewMortgageIndex >= 0 && this.newMortgages && this.newMortgages.length > this.cirfNavigation.selectedNewMortgageIndex) {
            return this.newMortgages[this.cirfNavigation.selectedNewMortgageIndex];
        } else {
            return null;
        }
    }

    get selectedExistingMortgage(): CirfMortgage {
        if (this.cirfNavigation && this.cirfNavigation.selectedExistingMortgageIndex >= 0 && this.existingMortgages && this.existingMortgages.length > this.cirfNavigation.selectedExistingMortgageIndex) {
            return this.existingMortgages[this.cirfNavigation.selectedExistingMortgageIndex];
        } else {
            return null;
        }
    }

    buildNavigationSections(): void {
        this.cirfService.buildNavigationSections();
    }

    isPreviousVisible(): boolean {
        return !(this.cirfNavigation?.isClientProfileSection() && this.cirfNavigation?.selectedClientIndex == 0);
    }

    isNextVisible(): boolean {
        return !(this.cirfNavigation?.isReviewSubmitSection());
    }

    isNextDisabled(): boolean {
        if (this.cirfNavigation.selectedClientIndex >= 0 && this.cirfNavigation.selectedClientIndex < this.clients.length) {
            let client = this.clients[this.cirfNavigation.selectedClientIndex]
            return this.cirfNavigation?.isClientProfileSection() && client && !(client.showAllFields || client.isAgreedToUploadDLNo());
        } else {
            return false;
        }

    }

    isAddNewClientVisible(): boolean {
        return this.cirfNavigation?.selectedClientIndex >= 0 && this.cirfNavigation?.isIdVerification2();
    }

    isAddNewMortgageVisible(): boolean {
        return this.cirfNavigation?.selectedNewMortgageIndex >= 0 && !!this.cirf?.cirfMatterData?.newMortgages[this.cirfNavigation?.selectedNewMortgageIndex]?.bankName;
    }

    isAddExistingMortgageVisible(): boolean {
        return this.cirfNavigation?.selectedExistingMortgageIndex >= 0 && !!this.cirf?.cirfMatterData?.existingMortgage[this.cirfNavigation?.selectedExistingMortgageIndex]?.bankName;
    }

    isSubmitVisible(): boolean {
        return this.cirfNavigation?.isReviewSubmitSection();
    }

    navigateNext(): void {
        if (this.cirfNavigation?.navigationSections?.length) {
            let activeSectionIndex = this.findActiveNavigationIndex();
            if (activeSectionIndex >= 0 && activeSectionIndex < this.cirfNavigation.navigationSections.length - 1) {
                this.setSelectedTopicAndSection({navigationSection: this.cirfNavigation.navigationSections[activeSectionIndex + 1]});
            }
        }
    }

    navigatePrev(): void {
        if (this.cirfNavigation?.navigationSections?.length) {
            let activeSectionIndex = this.findActiveNavigationIndex();
            if (activeSectionIndex >= 1) {
                //If the previous section is a client hidden section, we navigate to his personal details
                let navigationSection = this.cirfNavigation.navigationSections[activeSectionIndex - 1];
                if (navigationSection && navigationSection.clientIndex >= 0 && navigationSection.isIdVerification2()) {
                    let client = this.clients[navigationSection.clientIndex];
                    if (client && client.showAllFields || client.isAgreedToUploadDLNo()) {
                        this.setSelectedTopicAndSection({navigationSection: navigationSection});
                    } else {
                        this.setSelectedTopicAndSection({navigationSection: this.cirfNavigation.navigationSections[activeSectionIndex - 4]});
                    }

                } else {
                    this.setSelectedTopicAndSection({navigationSection: navigationSection});
                }

            }
        }
    }

    findActiveNavigationIndex(): number {
        if (this.cirfNavigation?.navigationSections?.length) {
            return this.cirfNavigation.navigationSections.findIndex(item =>
                (item.clientIndex == this.cirfNavigation.selectedClientIndex &&
                    item.newMortgageIndex == this.cirfNavigation.selectedNewMortgageIndex &&
                    item.existingMortgageIndex == this.cirfNavigation.selectedExistingMortgageIndex &&
                    item.sectionKey == this.cirfNavigation.selectedSectionKey)
                || (this.cirfNavigation.selectedNewMortgageIndex >= 0 && item.newMortgageIndex == this.cirfNavigation.selectedNewMortgageIndex)
                || (this.cirfNavigation.selectedExistingMortgageIndex >= 0 && item.existingMortgageIndex == this.cirfNavigation.selectedExistingMortgageIndex)
            )
        } else {
            return null;
        }
    }

    isDeleteClientVisible(): boolean {
        return this.clients?.length > 1 && this.cirfNavigation?.selectedClientIndex >= 0 && !this.cirfNavigation?.isClientNotesTopic();
    }

    isDeleteMortgageVisible(): boolean {
        return this.isDeleteNewMortgageVisible() || this.isDeleteExistingMortgageVisible();
    }

    isDeleteNewMortgageVisible(): boolean {
        return this.newMortgages?.length && this.cirfNavigation?.selectedNewMortgageIndex >= 0
            && !this.newMortgages[this.cirfNavigation?.selectedNewMortgageIndex].isCirfMortgageEmpty();
    }

    isDeleteExistingMortgageVisible(): boolean {
        return this.existingMortgages?.length && this.cirfNavigation?.selectedExistingMortgageIndex >= 0
            && !this.existingMortgages[this.cirfNavigation?.selectedExistingMortgageIndex].isCirfMortgageEmpty();
    }

    deleteSelectedClient(): void {
        if (this.isDeleteClientVisible()) {
            let client = this.clients[this.cirfNavigation?.selectedClientIndex];
            if (client) {
                this.deleteClient(client.id);
            }
        }
    }

    deleteSelectedMortgage(): void {
        let mortgage;
        let isNewMortgage : boolean = false;
        if (this.isDeleteNewMortgageVisible()) {
            mortgage = this.newMortgages[this.cirfNavigation?.selectedNewMortgageIndex];
            isNewMortgage = true
        }
        if (this.isDeleteExistingMortgageVisible()) {
            mortgage = this.existingMortgages[this.cirfNavigation?.selectedExistingMortgageIndex];
        }
        if (mortgage) {
            this.deleteMortgage(mortgage.id);
            this.cirfService?.cirf?.cirfMatterData?.removeMortgageAccessNavSection(isNewMortgage,
                isNewMortgage?this.cirfNavigation?.selectedNewMortgageIndex:this.cirfNavigation?.selectedExistingMortgageIndex);
        }
    }

    onScrollEvent() {
        Utils.toggleBackToTopBtnVisibility(this.pageContent, this.backToTopBtn)
    }

    backToTop() {
        Utils.backToTop(this.pageContent);
    }

}
